import React, { useEffect, useState } from "react";
import { CheckIcon, GlobeIcon, LockIcon, TrophyIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { MOCKUP_URL } from "../../data/landing";
const TOTAL_SPOTS = 100;
export function OfferSection() {
  const [spotsLeft, setSpotsLeft] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > 3 ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100;
  return <section id="offer" className="w-full bg-ink px-5 py-16 md:py-24" data-id="element-173" data-mp="3svzqjgfmnf9n">
      <div className="mx-auto max-w-xl" data-id="element-174" data-mp="3nxpvr6xtegok">
        <div className="text-center" data-id="element-175" data-mp="3nyr5n833gx4p">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-roseSoft" data-id="element-176" data-mp="3nvlivzhxu7c5">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="3ewzz610qcm9s" />
            Special launch offer
          </p>
          <h2 className="mt-3 font-serif text-[30px] font-bold leading-tight text-white md:text-5xl" data-id="element-178" data-mp="1asabfly1fi3j">
            Here's everything I'm giving you today
          </h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white text-ink shadow-2xl" data-id="element-179" data-mp="10tumnpmhgkx7">
          <img src={MOCKUP_URL} alt="Complete Clinical Pathway bundle" className="w-full bg-cream" data-id="element-180" data-mp="10rzz03jtuepf" />
          <div className="p-6 md:p-8" data-id="element-181" data-mp="15qkzm42zr0ee">
            <p className="text-center font-serif text-xl font-bold" data-id="element-182" data-mp="1ti8mmax4trbe">Breast Augmentation Clinical Pathway™</p>

            <dl className="mt-5 divide-y divide-line border-y border-line" data-id="element-183" data-mp="1ygjw2kjilzt3">
              {[["6 Premium Volumes", "$97"], ["5 Exclusive Professional Bonuses", "$197"]].map(([label, value]) => <div key={label} className="flex items-center justify-between gap-4 py-3.5" data-id="element-184" data-mp="1ol9shsdgxkd7">
                  <dt className="flex items-center gap-2 text-[16px] font-medium" data-id="element-185" data-mp="94rehyrh6qfa">
                    <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-186" data-mp="d5l54zwayjbv" />
                    {label}
                  </dt>
                  <dd className="text-[15px] text-inkSoft" data-id="element-187" data-mp="2as465iul5obr">
                    <s data-id="element-188" data-mp="2asm7gtw3usqj">{value}</s> value
                  </dd>
                </div>)}
            </dl>

            <p className="mt-5 text-center text-[15px] text-inkSoft" data-id="element-189" data-mp="25yrgd5e67bhf">
              Total value: <s className="font-semibold" data-id="element-190" data-mp="211rdf3cmaouj">$294</s>
            </p>
            <p className="mt-1 text-center text-[15px] text-inkSoft" data-id="element-191" data-mp="1x1h3jflpfeae">But today, the complete system is available for:</p>
            <p className="mt-2 text-center font-serif text-7xl font-extrabold leading-none text-cta md:text-8xl" data-id="element-192" data-mp="1rzruu6lyfcph">$27</p>
            <p className="mt-2 text-center text-xs font-bold uppercase tracking-widest text-inkSoft" data-id="element-193" data-mp="1n4cjpmfbzuwr">One-time payment · USD</p>

            <p className="mx-auto mt-4 flex max-w-sm items-start justify-center gap-2 rounded-xl bg-sand px-4 py-3 text-left text-[14px] leading-snug text-ink" data-id="element-194" data-mp="3hg0ynolkbxh5">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose" aria-hidden="true" data-id="element-195" data-mp="3cf3ifhk45dia" />
              Currency conversion is automatic — you'll see the price in your local currency at checkout.
            </p>

            <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-196" data-mp="3oxfoa6ujaa3p">
              {["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees", "7-day guarantee"].map(f => <li key={f} className="flex items-center gap-2 text-[15px]" data-id="element-197" data-mp="3204az2ppt7hq">
                    <CheckIcon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-198" data-mp="360o5dyiwlx06" />
                    {f}
                  </li>)}
            </ul>

            <div className="mt-7" data-id="element-199" data-mp="3fz3z899bfkdd">
              <div className="flex items-baseline justify-between gap-3 text-[14px] font-bold" data-id="element-200" data-mp="3fzdotvqg7pij">
                <span className="text-rose" data-id="element-201" data-mp="qal4jx5urvhc">Only {spotsLeft} spots left at the promotional price!</span>
                <span className="text-inkSoft" data-id="element-202" data-mp="v7tqm8u4gjnv">{Math.round(filled)}%</span>
              </div>
              <div className="relative mt-2 h-4 overflow-hidden rounded-full bg-roseSoft" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-203" data-mp="2451peoppei73">
                <div className="relative h-full overflow-hidden rounded-full bg-rose transition-[width] duration-300 ease-out" style={{
                width: `${filled}%`
              }} data-id="element-204" data-mp="2863p16nj8w9l">
                  <span className="animate-bar-shine absolute inset-y-0 left-0 w-1/3 bg-white/30" aria-hidden="true" data-id="element-205" data-mp="2i3i4b2xpzf0b" />
                </div>
              </div>
            </div>

            <div className="mt-7" data-id="element-206" data-mp="2rvxom6whofod">
              <CtaButton label="Get the Clinical Pathway™ for $27" data-id="element-207" data-mp="35v6r63rrvb9v" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-inkSoft" data-id="element-208" data-mp="35vgipvsgtqho">
                <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="30xnbczffeqft" />
                Secure checkout · Instant digital access · 7-day guarantee
              </p>
            </div>
            <Countdown data-id="element-210" data-mp="3pfxk9kh2t65z" />
          </div>
        </div>

        <p className="mt-8 text-center text-[16px] leading-relaxed text-white/80" data-id="element-211" data-mp="3ajq0umdhs8rr">
          For less than the cost of many professional educational resources, you'll have a structured case-review system
          you can return to whenever you're working through another educational breast augmentation case.
        </p>
      </div>
    </section>;
}